import {
  createElement,
  createContext,
  type ReactElement,
  useMemo,
  useReducer,
  useContext,
} from 'react';
import type { PeopleAccess, PeopleRoleKey } from './access';
import type { State } from './types';
import { type Mutation, reducer } from './mutations';

export interface AccessStore {
  state: State;
  dispatch: React.Dispatch<Mutation>;
}

const AccessContext = createContext({} as AccessStore);

export function AccessStoreProvider({ children }: { children: ReactElement }) {
  const [state, dispatch] = useReducer(reducer, {
    loaded: false,
    data: {} as Record<PeopleRoleKey, PeopleAccess>,
  });
  const props = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return createElement(AccessContext.Provider, { value: props }, children);
}

export function useAccessStore() {
  return useContext(AccessContext);
}
